import { render, staticRenderFns } from "./BugButton.vue?vue&type=template&id=7a97e3d0&scoped=true&"
import script from "./BugButton.vue?vue&type=script&lang=ts&"
export * from "./BugButton.vue?vue&type=script&lang=ts&"
import style0 from "./BugButton.vue?vue&type=style&index=0&id=7a97e3d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a97e3d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
